export enum Role {
  SuperAdmin = 'SuperAdmin',
  Admin = 'Admin',
  Member = 'Member',
}
